<template>
  <v-card class="invoice-card" :class="{'reverseInvoice': invoice.reverse_comment, 'cancelConnection': invoice.reverse_comment || invoiceCanceled}" flat @click="$emit('openInvoicePreview', invoice)" :disabled="disabled">
    <!-- {{invoice.reverseComment}}{{invoice.canceled}} -->
    <v-row>
      <v-col cols="12">
        <!-- <span class="invoice-card__title" :class="{'canceled': invoiceCanceled}" :inner-html.prop="invoiceFullNumber"> -->
        <span class="invoice-card__title" :inner-html.prop="invoiceFullNumber">
        </span>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="invoice-card__details">
        <span>
          {{invoice.date | sloDateTime}}
          <span class="d-none d-sm-inline-block invoice-card__details__devider" :style="{'borderRight': invoice.reverse_comment || invoiceCanceled ? '2px solid #000' : ''}"></span><br class="d-sm-none">
          {{invoice.moniker}}
          <span class="d-none d-sm-inline-block invoice-card__details__devider" :style="{'borderRight': invoice.reverse_comment || invoiceCanceled ? '2px solid #000' : ''}"></span><br class="d-sm-none">
          <!-- {{paymentType}} -->
          {{ payments }}
          <span class="d-none d-sm-inline-block invoice-card__details__devider" :style="{'borderRight': invoice.reverse_comment || invoiceCanceled ? '2px solid #000' : ''}"></span><br class="d-sm-none">
          {{tableName}}
        </span>
        <span class="float-right invoice-card__total" :class="{'canceled': invoice.reverse_comment}" :inner-html.prop="invoice.payment_amount | price">
        </span>
      </v-col>
    </v-row>
    <v-row v-if="invoice.reversed_invoice || invoice.reverse_invoice">
      <v-col cols="12" class="invoice-card__details" v-if="invoice.reversed_invoice">
          VEZA: {{`${invoice.reversed_business_premise_id}-${invoice.reversed_electronic_device_id}-${invoice.reversed_invoice_number}`}} <ButtonActionInfo @click="$emit('showInvoiceComment', invoice.reverse_comment)" />
      </v-col>
      <v-col cols="12" class="invoice-card__details" v-if="invoice.reverse_invoice">
        VEZA: {{`${invoice.reverse_business_premise_id}-${invoice.reverse_electronic_device_id}-${invoice.reverse_invoice_number}`}}
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="invoice-card__details" v-if="invoice.client">
        Klient: {{invoice.client_name}}
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import ButtonActionInfo from './ButtonActionInfo'

export default {
  components: {
    ButtonActionInfo
  },
  props: {
    invoice: {
      required: true,
      type: Object
    },
    businessUnitCode: {
      required: true,
      type: String
    },
    disabled: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {

    }
  },
  computed: {
    // eslint-disable
    payments () {
      if (this.invoice.payments && this.invoice.payments.length > 1) {
        return 'DELJENO PLAČILO'
      }
      if (this.invoice.payments && this.invoice.payments.length === 1) {
        return this.invoice.payments[0].payment_type_name
      }
      if (this.invoice.paymentMethods && this.invoice.paymentMethods.length >= 1) {
        return this.invoice.paymentMethods[0].name
      }
      return ((this.invoice.payments && this.invoice.payments[0].payment_type_name) || 'Napaka').toUpperCase()
    },
    invoiceFullNumber () {
      return `${this.businessUnitCode}-${this.invoice.electronic_device_id}-<span style="font-weight: bold; font-size: 25px;">${this.invoice.number}</span>`
    },
    paymentType () {
      return this.invoice.payment_type_name.toUpperCase()
    },
    invoiceCanceled () {
      return this.invoice.reverse_invoice !== null
    },
    reverseInvoice () {
      return this.invoice.payment_amount < 0
    },
    tableName () {
      return this.invoice.table_name
    }
  }
}
</script>

<style lang="scss">
.invoice-card.v-card--disabled > *:not(.v-card__progress) {
  opacity: 1;
}
</style>

<style lang="scss" scoped>
.invoice-card {
  &.reverseInvoice {
    color: red;
  }
  &.cancelConnection {
    background: #faeaea !important;
  }
  padding: 0 15px;
  font-size: 20px;
  border: 2px solid #EDEDED;

  &__title {
    &.canceled {
      color: red;
    }
  }

  &__details {
    line-height: 20px;
    font-size: 16px;
    color: #505B75;
    &__devider {
      width: 1px;
      height: 100%;
      margin: 0 15px 0 13px;
      border-right: 2px solid #EDEDED;
    }
  }
  &__total {
    padding-right: 20px;
    font-size: 25px;
    font-weight: bold;
    &.canceled {
      color: red;
    }
  }
  .commands {
    margin-right: 20px;
  }
}
</style>
